module.exports = __webpack_public_path__ + "img/roll4.cfbceef0.png";